var App = App || {};

App.Modals = (function () {
    'use strict';

    const fetchModalUrls = () => {

        return fetch('/Api/Modals/GetModalUrls', {
            method: 'GET'
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(result => {
                if (!Array.isArray(result)) {
                    return [];
                }

                return result.filter(url => typeof url === "string" && url.trim() !== "");
            })
            .catch(error => {
                console.error('Error fetching modal URLs:', error);
                return [];
            });
    };

    const openModalFromAnchor = (modalUrls, anchor) => {
        const href = anchor.getAttribute("href")?.trim() ?? "";
        if (!href || href.startsWith("#")) {
            return false;
        }

        const normalizedModalUrls = Array.isArray(modalUrls)
            ? modalUrls.filter(url => typeof url === "string")
            : [];

        const isModalUrl = normalizedModalUrls.some(url => url.toLowerCase() === href.toLowerCase());
        if (!isModalUrl) {
            return false;
        }

        fetch(href, { method: "GET" })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then(result => {

                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = result;

                const modalElement = tempDiv.querySelector(".modal, .offcanvas");
                if (!modalElement) return;

                const modalData = {
                    id: modalElement.id,
                    content: modalElement.outerHTML
                };

                if (!modalData.id) return;

                if (!document.getElementById(modalData.id)) {
                    document.body.insertAdjacentHTML("beforeend", modalData.content);
                }

                showModalInstance(modalData.id, anchor);
            })
            .catch(error => {
                console.error("Error loading modal:", error);
            });

        return true;
    }

    const showModalInstance = (modalId, anchor) => {

        const modalElement = document.getElementById(modalId);
        if (!modalElement) return;

        App.Helpers.responsiveTables(modalElement);

        let hiddenEvent = null;
        let modalInstance = null;

        if (modalElement.classList.contains("modal")) {
            hiddenEvent = "hidden.bs.modal";
            modalInstance = new bootstrap.Modal(modalElement);
        }
        else if (modalElement.classList.contains("offcanvas")) {
            hiddenEvent = "hidden.bs.offcanvas";
            modalInstance = new bootstrap.Offcanvas(modalElement);
        }

        if (!hiddenEvent || !modalInstance) return;

        modalElement.addEventListener(hiddenEvent, () => {

            const speedBumpTriggeredByModal = App.SpeedBump.getTriggeredByModal();
            if (!speedBumpTriggeredByModal) {
                modalInstance.dispose();
                modalElement.remove();
            }

            if (anchor !== null) {
                anchor.focus();
                anchor.blur();
            }
        });

        modalInstance.show();
    }

    return {
        fetchModalUrls,
        openModalFromAnchor
    };

})();
